import { Typography } from "antd";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";

import { UserForm } from "../UserForm";

import { useUserEditForm } from "./hooks";

const UserEdit = () => {
  const form = useUserEditForm();

  return (
    <>
      <Header>
        <Typography.Title level={2}>
          <FormattedMessage defaultMessage="Edit user" />
        </Typography.Title>
      </Header>
      <UserForm {...form} />
    </>
  );
};

export default UserEdit;
